(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/challenge/assets/javascripts/components/overview/overview-container.js') >= 0) return;  svs.modules.push('/modules/challenge/assets/javascripts/components/overview/overview-container.js');
"use strict";


const _ReactRouterDOM = ReactRouterDOM,
  withRouter = _ReactRouterDOM.withRouter;
const mapStateToProps = (state, _ref) => {
  let match = _ref.match;
  const drawNumber = Number(match.params.drawNumber);
  const coupon = svs.challenge.helpers.getCouponByDrawNumber(state, drawNumber);
  return {
    betSum: coupon.betSum,
    draw: svs.challenge.helpers.getDrawByDrawNumber(drawNumber, state),
    drawEvents: coupon.drawEvents,
    rowPrice: coupon.chosenBetPrice
  };
};
svs.challenge.OverviewContainer = withRouter(ReactRedux.connect(mapStateToProps)(svs.challenge.Overview));

 })(window);